import { useAtomValue } from "jotai";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { canAccessRoute } from "@/routes/utils/routePermission";
import { menusAtom, permissionsAtom } from "@/store/auth";

/**
 * 子路由权限守卫：无菜单或无权限时重定向至 /403
 * 鉴权 loading 由外层 ProtectedRoute 统一处理
 */
export const RoutePermissionGuard = () => {
  const location = useLocation();
  const menus = useAtomValue(menusAtom);
  const permissions = useAtomValue(permissionsAtom);

  if (!canAccessRoute(location.pathname, menus, permissions)) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  return <Outlet />;
};
